import { render, staticRenderFns } from "./position-box.vue?vue&type=template&id=40c1bc81&scoped=true"
import script from "./position-box.vue?vue&type=script&lang=js"
export * from "./position-box.vue?vue&type=script&lang=js"
import style0 from "./position-box.vue?vue&type=style&index=0&id=40c1bc81&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40c1bc81",
  null
  
)

export default component.exports